import { render, staticRenderFns } from "./detectionreport_mobile.vue?vue&type=template&id=cc3da306&"
import script from "./detectionreport_mobile.vue?vue&type=script&lang=js&"
export * from "./detectionreport_mobile.vue?vue&type=script&lang=js&"
import style0 from "./detectionreport_mobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports